module.exports = __webpack_public_path__ + "static/media/info_filled.a4620883.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/info_filled.svg
// module id = 614
// module chunks = 0